import { useEffect, useState } from 'react';
import Header from '../../common/Header/Header';
import './ArrivalsDepartures.scss';
import SymbolKey from '../../common/SymbolKey/SymbolKey';
import ArrivalLine from './subComponents/ArrivalLine/ArrivalLine';
import Hub from '../../api/controllers/Hub/Hub';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import GoodsIn from '../../api/controllers/GoodsIn/GoodsIn';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';

// ArrivalsDepartures Screen
const ArrivalsDepartures = () => {
  const [selected, setSelected] = useState({ movementType: 'imports', category: 'international' });
  const [hub, setHub] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [arrivals, setArrivals] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getHub = () => {
    setLoading(true);
    Hub.show(hubId)
      .then(hub => {
        setLoading(false);
        setHub(hub);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getMovements = async () => {
    setLoading(true);
    const params = {
      category: selected.category,
      hubId: hubId,
      status: 'pending',
      endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    };
    if (
      selected.movementType == 'collections' ||
      selected.movementType == 'imports' ||
      selected.movementType == 'subcontracts_in'
    ) {
      GoodsIn.all(params)
        .then(response => {
          setArrivals(response.items);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    } else {
      GoodsOut.all(params)
        .then(response => {
          setArrivals(response.items);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  useEffect(() => {
    getHub();
  }, []);

  useEffect(() => {
    getMovements();
  }, [selected]);

  return (
    <div className="arrivals_departures_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <Header rightButton={'home'} hideQR title={`Arrival Times: ${hub?.name || ''}`} />
      <div className="movement_selector">
        <button
          className={`${selected.movementType == 'imports' ? 'selected' : ''}`}
          onClick={() => setSelected({ movementType: 'imports', category: 'international' })}
        >
          Import Trailers
        </button>
        <button
          className={`${selected.movementType == 'exports' ? 'selected' : ''}`}
          onClick={() => setSelected({ movementType: 'exports', category: 'international' })}
        >
          Export Trailers
        </button>
        <button
          className={`${selected.movementType == 'collections' ? 'selected' : ''}`}
          onClick={() => setSelected({ movementType: 'collections', category: 'domestic' })}
        >
          Goods In (Domestic)
        </button>
        <button
          className={`${selected.movementType == 'deliveries' ? 'selected' : ''}`}
          onClick={() => setSelected({ movementType: 'deliveries', category: 'domestic' })}
        >
          Goods Out (Domestic)
        </button>
        <button
          className={`${selected.movementType == 'subcontracts_in' ? 'selected' : ''}`}
          onClick={() =>
            setSelected({ movementType: 'subcontracts_in', category: 'subcontracted' })
          }
        >
          Goods In (Subcontract)
        </button>
        <button
          className={`${selected.movementType == 'subcontracts_out' ? 'selected' : ''}`}
          onClick={() =>
            setSelected({ movementType: 'subcontracts_out', category: 'subcontracted' })
          }
        >
          Goods Out (Subcontract)
        </button>
      </div>
      <div className="arrivals">
        {arrivals?.map(arrival => {
          return (
            <ArrivalLine
              movement={arrival}
              category={selected.category}
              key={arrival?.id}
              movementType={selected.movementType}
              getMovements={getMovements}
              hubId={hubId}
            />
          );
        })}
      </div>
      <SymbolKey type="arrivals" />
    </div>
  );
};

export default ArrivalsDepartures;
